import { createReducer, createNamespacer } from './../../commons/js/utils/reducer';
import { fromPairs as _fromPairs, intersection } from 'lodash';


const initialState = {
    list: {
        isLoading: false,
        spools: [],
        error: "",
        packageOptions: [],
        package: { label: '', value: '' },
        statuses: [],
        bay:[],
        size: { label: 'All', value: '' },
        showSubpackageModal: false,
        spoolSizes: [],
        statusList: [],
        selectedSpools: [],
        packageSpools: [],
        currentPage: 1,
        pageCount: 1,
        url: '',
        status: { label: 'All', value: '' },
        stages: [],
        stage: { label: 'All', value: '' },
        spoolSearch: '',
        dateFilter: '',
        toggleAll: false,
        loadedFilter: { label: 'All', value: '' },
        loadedOptions: [
            { label: 'All', value: '' },
            { label: 'No', value: 'false' },
            { label: 'Yes', value: 'true' }
        ],
        pdfView: false,
        approved: true,
        spoolsCount: 0,
        highlightSpoolState: '',
        showMoveSpoolPopup: false,
        spooledPackages: [],
        spools_count: 0,
        filtered_spools_count: 0,
        showReplaceSpoolId: 0,
        spoolDrawing: {
            name: "",
            value: "",
            error: "",
            showError: "",
        },
        drawingLoading: false,
        spoolDetailsId: 0,
        spoolProductionDetails: [],
        spoolCode: '',
        spoolProductionUrl:'',
        packageDetails: {},
        clLength: '',
        clLengthFilter: {label: 'Select', value: ''},
        loadClLengthFilters:[
            { label: '=', value: '=' },
            { label: '>', value: '>' },
            { label: '<', value: '<' },
            { label: '<=', value: '<=' },
            { label: '>=', value: '>=' }
        ],
    }
}

const listSpools = createNamespacer("SPOOLS_LIST")

export const listReducer = createReducer(initialState.list, {
    [listSpools("SET_SPOOLS")]: (state, action) => {
        const responseMapping = {
            // spools: 'spools',
            requiredDate: 'required_date',
            noOfSpoolsAssigned: 'spools_assigned',
            noOfSpoolsShipped: 'spools_shipped',
            projectName: 'project_name',
            packageID: 'packageID',
            projectCode: 'project_code',
            // approved: 'approved',
        }

        if (!action.payload.filtersApply) {
            responseMapping.spools = 'spools'
        }

        let loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                
                return [key, action.payload.value[responseKey]]
            })
        )

        if (!action.payload.filtersApply) {
            let spoolsArray = loadedFields.spools

            let checkedStatus = spoolsArray.map((spools) => {
                return {
                    ...spools,
                    checked: false
                }
            })

            loadedFields = {
                ...loadedFields,
                spools: checkedStatus
            }
        }

        let returnStates = {
            ...state,
            ...loadedFields,
            packageSpools: loadedFields.spools,
            spools_count: action.payload.value.spools_count,
        }

        if (!action.payload.filtersApply) {
            returnStates.pageCount = action.payload.pages
        }

        return returnStates
    },

    "SHOW_REPLACE_SPOOL": (state, action) => {
        return {
            ...state,
            showReplaceSpoolId: action.payload.value,
        }
    },
    "SET_SPOOL_PRODUCTION_URL": (state,action) => {
        return {
            ...state,
            spoolProductionUrl: action.payload.value,
        }
    },
    [listSpools("SET_PRODUCTION_ID")]: (state, action) => {
        return {
            ...state,
            spoolDetailsId: action.payload.value,
        }
    },
    [listSpools("SET_SPOOL_DRAWING")]: (state, action) => {
        return {
            ...state,
            spoolDrawing: {
                ...state.spoolDrawing,
                value: action.payload.value,
                name: action.payload.value.name,
            },
        }
    },

    [listSpools("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },

    [listSpools("FILTER_SPOOLS")]: (state, action) => {        
        let checkedAllStatus
        let checkedStatus = action.payload.value.map((spools) => {
            return {
                ...spools,
                checked: false
            }
        })

        let spoolsId = checkedStatus.map((spool) => {
            return spool.id
        })

        let commonArray = intersection(state.selectedSpools, spoolsId)

        if (commonArray.length === spoolsId.length) {
            checkedAllStatus = true
        } else {
            checkedAllStatus = false
        }
        
        return {
            ...state,
            spools: checkedStatus,
            pageCount: action.payload.pages,
            spoolsCount: action.payload.spoolsCount,
            filtered_spools_count: action.payload.filtered_spools_count,
            toggleAll: checkedAllStatus
        }
    },
    [listSpools("SET_PDF_VIEW")]: (state, action) => {
        return {
            ...state,
            pdfView: action.payload.value,
        }
    },
    [listSpools("CLEAR_PDF_URL")]: (state, action) => {
        return {
            ...state,
            url: ''
        }
    },
    [listSpools("CLEAR_REPLACE_FORM")]: (state, action) => {
        return {
            ...state,
            spoolDrawing: {
                ...initialState.list.spoolDrawing
            }
        }
    },
    [listSpools("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.list
        }
    },
    [listSpools("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [listSpools("LOAD_STATUSES")]: (state, action) => {
        return {
            ...state,
            statuses: action.payload.value,
            statusList: [
                { label: 'All', value: '' },
                ...action.payload.value
            ],
        }
    },
    [listSpools("LOAD_BAY")]: (state, action) => {
        return {
            ...state,
            bay: [
                {label:'Bay-1', value:'1'},
                {label:'Bay-2', value:'2'},
                {label:'Bay-3', value:'3'},
                {label:'Bay-4', value:'4'}
            ]
        }
    },
    [listSpools("LOAD_STAGES")]: (state, action) => {
        return {
            ...state,
            stages: [
                { label: 'All', value: '' },
                ...action.payload.value
            ],
        }
    },
    [listSpools("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [listSpools("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [listSpools("CLEAR_PACKAGE_OPTIONS")]:(state, action) => {
        return {
            ...state,
            packageOptions: initialState.list.packageOptions,
        }
    },
    [listSpools("SET_PACKAGE_OPTIONS")]: (state, action) => {
        return {
            ...state,
            packageOptions: [
                ...state.packageOptions,
                ...action.payload.value
            ],
        }
    },
    [listSpools("SET_SPOOL_SIZES")]: (state, action) => {
        return {
            ...state,
            spoolSizes: [
                { label: 'All', value: '' },
                ...action.payload.value
            ],
        }
    },
    [listSpools("SET_CL_LENGTH")]: (state, action) => {
        return {
            ...state,
            clLength: action.payload.value,
        }
    },
    [listSpools("SET_SPOOL_SEARCH")]: (state, action) => {
        return {
            ...state,
            spoolSearch: action.payload.value
        }
    },
    [listSpools("SET_PACKAGE")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }
        return {
            ...state,
            package: {
                ...action.payload.value
            }
        }
    },
    [listSpools("SET_SPOOL_PDF")]: (state, action) => {
        return {
            ...state,
            url: action.payload.value,
        }
    },
    [listSpools("CLEAR_URL")]: (state, action) => {
        return {
            ...state,
            url: initialState.list.url,
        }
    },
    [listSpools("SET_SIZE")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            size: action.payload.value
        }
    },
    [listSpools("SET_STATUS_FILTER")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            status: action.payload.value
        }
    },
    [listSpools("SET_STAGE_FILTER")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            stage: action.payload.value
        }
    },
    [listSpools("SET_DATE_FILTER")]: (state, action) => {
        return {
            ...state,
            dateFilter: action.payload.value
        }
    },
    [listSpools("SET_LOAD_FILTER")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            loadedFilter: action.payload.value
        }
    },
    [listSpools("SET_CL_LENGTH_FILTER")]: (state, action) => {
        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            clLengthFilter: action.payload.value
        }
    },
    "SET_CREATE_PACKAGE": (state, action) => {
        return {
            ...state,
            showSubpackageModal: action.payload.value,
        }
    },

    "SET_MOVE_SPOOLS_POPUP": (state, action) => {
        return {
            ...state,
            showMoveSpoolPopup: action.payload.value,
        }
    },
    [listSpools("SET_PACKAGE_OPTION")]: (state, action) => {
        return {
            ...state,
            package: action.payload.value,
        }
    },
    [listSpools("SET_PACKAGE_DETAILS")]: (state, action) => {
        return {
            ...state,
            packageDetails: action.payload.value,
            approved: action.payload.value.fabrication.approved,
            gdpProject: action.payload.value.gdp_project
        }
    },

    [listSpools("SET_DRAWING_LOADING")]: (state, action) => {
        return {
            ...state,
            drawingLoading: action.payload.value,
        }
    },

    [listSpools("SET_SELECTED_SPOOLS")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.selectedSpoolIds,
            spools: action.payload.newSpools,
            toggleAll: action.payload.checkedAllStatus
        }
    },
    [listSpools("REMOVE_SELECTED_SPOOLS")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.newSelectedSpoolIds,
            spools: action.payload.newSpools,
            toggleAll: action.payload.checkedAllStatus
        }
    },
    [listSpools("TOGGLE_ALL_PACKAGES")]: (state, action) => {
        return {
            ...state,
            toggleAll: !state.toggleAll,
            spools: action.payload.newSpools,
            selectedSpools: action.payload.selectedSpoolIds
        }
    },
    [listSpools("SET_SELECTED_SPOOLS_EMPTY")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.value,
        }
    },
    [listSpools("HIGHLIGHT_SPOOL")]: (state, action) => {
        return {
            ...state,
            highlightSpoolState: action.payload.highlightSpool,
        }
    },
    [listSpools("SET_SPOOLED_PACKAGES")]: (state, action) => {
        return {
            ...state,
            spooledPackages: action.payload.value,
        }
    },
});
